export default {
    game_id: "ring_of_fire_xl",
    gameName : "Ring Of Fire XL",

    stageWidth: 1280,
    stageHeight: 720,

    scripts: [
        'framework/src/vendor/jquery.min.js',
        'framework/src/vendor/tween.js',
        'framework/src/vendor/ph.js'
    ],

    game: {
        audio: {
            tracks: []
        },
        freespins: {
            autostart: true
        },
        webfonts: [
            //your other webfonts, if any
            "UbuntuMono-Regular",
            "Audiowide-Regular",
        ],
    },
    system: {
        audio: {
            tracks: [
                {
    name: 'Jackpot_sound',
    classVol: 'volume.normalWin',
    loop: false,
},
{
    name: 'JokerBonus_alert',
    classVol: 'volume.normalWin',
    loop: false,
},
            ]
        }
    }
}